import { render, staticRenderFns } from "./DashboardBottomWidgets.vue?vue&type=template&id=ecf4961e&scoped=true"
import script from "./DashboardBottomWidgets.vue?vue&type=script&lang=js"
export * from "./DashboardBottomWidgets.vue?vue&type=script&lang=js"
import style0 from "./DashboardBottomWidgets.vue?vue&type=style&index=0&id=ecf4961e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf4961e",
  null
  
)

export default component.exports